import { useRouter } from 'next/router';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { changeAppLanguage } from '@src/i18n';
import { postUserLanguageCall } from '@src/store/actions/user';
import { AppLanguage, setGuestLanguage, isPreLoginLanguageRoute, isLanguageLocked } from '@src/i18n/languagePolicy';

export default function useLanguageSelection(): { selectLanguage: (language: AppLanguage) => void } {
	const { pathname } = useRouter();
	const signedIn = useSelector((state: RootStateOrAny) => state.session.isSignedIn);
	const dispatch = useDispatch();

	return {
		selectLanguage: language => {
			if (isLanguageLocked(pathname)) return;
			if (!isPreLoginLanguageRoute(pathname) && (signedIn === true || signedIn === 'true')) {
				dispatch(postUserLanguageCall({ language }));
			} else {
				setGuestLanguage(language);
				changeAppLanguage(language)['catch'](() => undefined);
			}
		},
	};
}
